// chat
export const GET_ENROLLMENT = "/api/v1/enrollments/active";
export const POST_NEXT = "/api/v1/chat/next";
export const SEND_MESSAGE_CODE = "/api/v1/chat";
export const GET_ACTIONS = "/api/v1/actions";
export const LOGIN = "/api/v1/auth/login";
